import { render, staticRenderFns } from "./VisitHistoryCard.vue?vue&type=template&id=778e9adc&scoped=true"
import script from "./VisitHistoryCard.vue?vue&type=script&lang=ts"
export * from "./VisitHistoryCard.vue?vue&type=script&lang=ts"
import style0 from "./VisitHistoryCard.vue?vue&type=style&index=0&id=778e9adc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778e9adc",
  null
  
)

export default component.exports